export class AdministrativeAreaDTO {
  constructor(readonly area_name: string, readonly return_period: number) {}
}
